import React from 'react';
import { ReportWheelGameContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Tables, Displays, Inputs, Buttons, Modals } from 'components';
import { retailerService } from 'apiServices';
import { renderRedemptionStatus } from 'utils/functions/RedemptionStatus';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import moment from 'moment';
import 'moment-timezone';
import { ReportWheelGameExportContainer } from '../Modals';
import {
  parseFilterFromSearchParams,
  buildApiQueryString,
  mergeFilterIntoParams,
  legacyQueryStringToObject,
  clearFilterParams,
} from 'utils/functions/filterUrl';

const MEMBER_TYPE = '2'; // consumer
const API_EXTRA = { memberType: MEMBER_TYPE };
const API_EXTRA_EXPORT = { memberType: MEMBER_TYPE, pagination: 'false' };

const todayStr = () => moment().format('YYYY-MM-DD');

class ReportWheelGameContainer extends React.Component {
  state = {
    isLoading: true,
    isLoadingTable: true,
    pagination: null,
    isShowModal: false,
    exportData: [],
  };

  componentDidMount() {
    scrollToTopPageFN();
    const { searchParams, setSearchParams } = this.props.router;
    const needsSeed =
      !searchParams.get('limit') || !searchParams.get('start_date');
    if (needsSeed) {
      const sp = new URLSearchParams(searchParams);
      if (!sp.get('limit')) sp.set('limit', '10');
      if (!sp.get('page')) sp.set('page', '1');
      if (!sp.get('start_date')) sp.set('start_date', todayStr());
      if (!sp.get('end_date')) sp.set('end_date', todayStr());
      setSearchParams(sp, { replace: true });
      this.fetchData(buildApiQueryString(sp, { extra: API_EXTRA }));
    } else {
      this.fetchData(buildApiQueryString(searchParams, { extra: API_EXTRA }));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.search !== this.props.router.location.search
    ) {
      this.setState({ isLoadingTable: true });
      this.fetchData(
        buildApiQueryString(this.props.router.searchParams, { extra: API_EXTRA })
      );
    }
  }

  fetchData = async (stringQuery) => {
    let res = await retailerService.GET_REPORT_WHEEL_GAME_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
        isLoading: false,
        isLoadingTable: false,
      });
    }
  };

  ensureDateDefaults = (sp) => {
    if (!sp.get('start_date')) sp.set('start_date', todayStr());
    if (!sp.get('end_date')) sp.set('end_date', todayStr());
    return sp;
  };

  handlePageClick = (e) => {
    const sp = new URLSearchParams(this.props.router.searchParams);
    sp.set('page', String(e.selected + 1));
    this.props.router.setSearchParams(this.ensureDateDefaults(sp));
  };

  handleFilterSelect = (legacyQs) => {
    const patch = legacyQueryStringToObject(legacyQs);
    const sp = mergeFilterIntoParams(this.props.router.searchParams, patch, {
      resetPage: true,
    });
    this.props.router.setSearchParams(this.ensureDateDefaults(sp));
  };

  handleClearFilter = () => {
    const sp = clearFilterParams(this.props.router.searchParams, dataFilter);
    sp.set('start_date', todayStr());
    sp.set('end_date', todayStr());
    this.props.router.setSearchParams(sp);
  };

  handleClickExport = async () => {
    const query = buildApiQueryString(this.props.router.searchParams, {
      extra: API_EXTRA_EXPORT,
    });
    let res = await retailerService.GET_REPORT_WHEEL_GAME_LIST(query);
    if (res && res.status === 200) {
      this.setState({ exportData: res.data.docs, isShowModal: true });
    }
  };

  handleCloseModal = () => {
    this.setState({ isShowModal: false });
  };

  render() {
    const { isLoading, data, pagination, isLoadingTable, isShowModal, exportData } =
      this.state;
    const { searchParams } = this.props.router;
    const { filterValues } = parseFilterFromSearchParams(
      searchParams,
      dataFilter,
      { defaultLimit: 10 }
    );
    return (
      <ReportWheelGameContainerStyled>
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading />
          </div>
        ) : (
          <>
            <div className="top_sec">
              <div className="ts_left_col">
                Report การแลกของรางวัล (Wheel game)
              </div>
              <div className="ts_right_col">
                <Buttons.BtnNormal
                  theme_normal_btn
                  label="Export"
                  onClick={this.handleClickExport}
                />
              </div>
            </div>
            <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={dataFilter}
                btnLabel="เลือก"
                initialValues={filterValues}
                onQueryFilter={this.handleFilterSelect}
                onClear={this.handleClearFilter}
              />
            </div>
            <Tables.TableNormal
              theme_standard_table_normal
              showPagination
              useNo
              data={data}
              pagination={pagination}
              handlePageClick={this.handlePageClick}
              isLoading={isLoadingTable}
              columns={columns}
            />
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={isShowModal}
          onCloseModal={this.handleCloseModal}
        >
          <div className="m_report_container">
            <ReportWheelGameExportContainer
              onCloseModal={this.handleCloseModal}
              data={exportData}
            />
          </div>
        </Modals.BodyEmpty>
      </ReportWheelGameContainerStyled>
    );
  }
}

const dataFilter = [
  {
    accessor: 'dateBy',
    placeHolder: 'ระยะเวลา',
    filter: {
      fieldQuery: 'types',
      type: 'dateGroup',
      initialValues: { level1: 'day' },
      options: [
        { label: 'วันนี้', value: 'day' },
        { label: 'เดือนนี้', value: 'month' },
        { label: 'ไตรมาส', value: 'quarter' },
        { label: 'ระหว่างวันที่', value: 'date_range' },
      ],
    },
  },
  {
    accessor: 'rewardBy',
    length: '311px',
    filter: {
      fieldQuery: 'reward_name',
      type: 'text',
      placeholder: 'ค้นหาชื่อรางวัล',
    },
  },
];

const columns = [
  {
    title: 'ลำดับ',
    field: 'no',
    headerStyle: { textAlign: 'center', width: '50px', flexShrink: 0 },
    style: { textAlign: 'center', width: '50px', flexShrink: 0 },
  },
  {
    title: 'วันที่แลก',
    field: 'created_at',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ value }) =>
      `${moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}`,
  },
  {
    title: 'ชื่อผู้แลก',
    field: 'firstname_shipping',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ origin }) => (
      <div>
        {`${origin.firstname_shipping || origin?.consumer_detail?.firstname || '-'} ${
          origin.lastname_shipping || origin?.consumer_detail?.lastname || ''
        }`}
      </div>
    ),
  },
  {
    title: 'เบอร์โทรศัพท์',
    field: 'phone_number_shipping',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ origin, value }) => (
      <div>{value || origin?.consumer_detail?.phone_number || '-'}</div>
    ),
  },
  {
    title: 'ชื่อของรางวัล',
    field: 'reward_name',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
  },
  {
    title: 'จังหวัด',
    field: 'address_province',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ value }) => <div>{value || '-'}</div>,
  },
  {
    title: 'สถานะ',
    field: 'status',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'center' },
    render: ({ origin }) => (
      <div>{renderRedemptionStatus(origin.reward_type, origin.status)}</div>
    ),
  },
];

export default withRouter(ReportWheelGameContainer);
